import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from 'src/store';
import QualityControl from './QualityControl';
import { EditMetaDataProps } from './types';

const QualityControlDetail: FC<any> = ({ expanded, accordionInfo, handleToogleAccordion }: EditMetaDataProps) => {
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const [open, setOpen] = React.useState(false);

  const qcRows = [
    createData(
      'Redacted Certified Copy:',
      documentDetail.data[0]?.isf_doc_viewer_red_certified_copy === 'Y' ? 'Yes' : 'No'
    )
  ];

  function createData(name: string, calories: string | null) {
    return { name, calories };
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Accordion
        expanded={accordionInfo.position === expanded}
        onChange={handleToogleAccordion(accordionInfo.position)}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
          <Typography sx={{ width: '60%', flexShrink: 0 }} className="acc-header">
            Sponsor Review{' '}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableBody>
                  {qcRows.map(row => (
                    <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell align="right">{row.calories}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <QualityControl handleClose={handleClose} open={open} setOpen={setOpen}></QualityControl>
    </>
  );
};

export default QualityControlDetail;
